import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonMenu,
  IonItem,
  IonList,
  IonMenuButton,
  IonButtons,
  IonButton,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonModal,
  IonBackButton,
} from "@ionic/react";
import { RouteComponentProps, withRouter } from "react-router";

// CSS
import "./SignificantChangesListPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconClearSearch from "../../assets/Button_Cancel@3x.png";

// Controllers
import { IScreenProps, IUser, IGuideline, IAlgorithm, IPatientAge, ISignificantChange } from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";

// Components
import AppCard from "../../components/AppCard";
import SignificantChangeCell from "../../components/SignificantChangeCell";

import _ from "lodash";

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  acknowledgedCardCollapsed: boolean;
};

class SignificantChangesListPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      acknowledgedCardCollapsed: true,
    };
  }

  componentDidMount() {}

  significantChangeCellClicked(significantChange: ISignificantChange) {
    this.props.screenProps.navigateToGuideline(
      significantChange.GLID,
      this.props.match.params.tab,
      this.props.history,
      null,
      "Significant Change List"
    );
  }

  significantChangeCellAcknowledgeButtonClicked(significantChange: ISignificantChange) {
    this.props.screenProps.acknowledgeSignificantChange(significantChange, "Significant Change List");
  }

  render() {
    let acknowledgedSignificantChangeCells: any = [];
    let unacknowledgedSignificantChangeCells: any = [];

    let significantChangeAckIDs = this.props.screenProps.significantChangeAcks.map(
      (significantChangeAck) => significantChangeAck.cnid
    );

    // render significant changes
    for (
      let significantChangeIndex = 0;
      significantChangeIndex < this.props.screenProps.significantChanges.length;
      significantChangeIndex++
    ) {
      let significantChange = this.props.screenProps.significantChanges[significantChangeIndex];

      const guidelineSummary = this.props.screenProps.guidelineSummaries.find(
        (guidelineSummary) => guidelineSummary.GLID === significantChange.GLID
      );
      let isAcknowledged = significantChangeAckIDs.includes(significantChange.id);

      let showAcknowledgeButton = false;
      if (this.props.screenProps.user && this.props.screenProps.user.uid != null) {
        showAcknowledgeButton = true;
      }

      let significantChangeCell = (
        <div key={significantChange.id}>
          <SignificantChangeCell
            significantChange={significantChange}
            guidelineSummary={guidelineSummary}
            acknowledged={isAcknowledged}
            showAcknowledgeButton={showAcknowledgeButton}
            cellClicked={this.significantChangeCellClicked.bind(this)}
            acknowledgeButtonClicked={this.significantChangeCellAcknowledgeButtonClicked.bind(this)}
          />
        </div>
      );

      if (isAcknowledged) {
        acknowledgedSignificantChangeCells.push(significantChangeCell);
      } else {
        unacknowledgedSignificantChangeCells.push(significantChangeCell);
      }
    }

    let emptyUnacknowledgedChangesLayout = null;

    if (unacknowledgedSignificantChangeCells.length <= 0) {
      if (this.props.screenProps.significantChanges.length > 0) {
        emptyUnacknowledgedChangesLayout = (
          <div className="emptySignificantChanges">
            You’re caught up to date on updates. Any future updates will appear here.
          </div>
        );
      } else {
        emptyUnacknowledgedChangesLayout = (
          <div className="emptySignificantChanges">Any unacknowledged updates will appear here.</div>
        );
      }
    }

    let emptyAcknowledgedChangesLayout = null;

    if (acknowledgedSignificantChangeCells.length <= 0) {
      if (this.props.screenProps.significantChanges.length > 0) {
        emptyAcknowledgedChangesLayout = (
          <div className="emptySignificantChanges">Any acknowledged updates will appear here.</div>
        );
      } else {
        emptyAcknowledgedChangesLayout = (
          <div className="emptySignificantChanges">Any acknowledged updates will appear here.</div>
        );
      }
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle>Updates</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div className="dashboardContentContainer globalContentMargin">
            <AppCard
              title="Unacknowledged"
              badgeCount={unacknowledgedSignificantChangeCells.length}
              removeContentPadding
              darkMode={this.props.screenProps.darkMode}
            >
              <div className="">{unacknowledgedSignificantChangeCells}</div>
              {emptyUnacknowledgedChangesLayout}
            </AppCard>

            <AppCard
              title="Acknowledged"
              removeContentPadding
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={this.state.acknowledgedCardCollapsed}
              collapsedButtonClicked={() =>
                this.setState({ acknowledgedCardCollapsed: !this.state.acknowledgedCardCollapsed })
              }
            >
              <div className="">{acknowledgedSignificantChangeCells}</div>
              {emptyAcknowledgedChangesLayout}
            </AppCard>
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(SignificantChangesListPage);
